import { Controller } from "@hotwired/stimulus"

// LOC-100: the tier notice (Decision 0043) is server-rendered open. The X at the
// top right is a real dismiss (same POST as the button); Escape submits that
// form too, so the flag is cleared and the notice does not return. Focus lands
// on the X so a keyboard user is inside the dialog straight away.
export default class extends Controller {
  static targets = ["closeForm", "closeButton"]

  connect() {
    if (this.hasCloseButtonTarget) this.closeButtonTarget.focus()
  }

  close(event) {
    event.preventDefault()
    if (this.hasCloseFormTarget) this.closeFormTarget.requestSubmit()
  }
}
